'use strict';

const locales = ["ko", "en"];
const DEFAULT_LOCALE = "ko";
const i18nConfig = {
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales
  }
};
const HEADER_KEY_LOCALE = "FlexTeam-Locale";
const COOKIE_KEY_LOCALE = "FlexTeam-Locale";

exports.COOKIE_KEY_LOCALE = COOKIE_KEY_LOCALE;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports.HEADER_KEY_LOCALE = HEADER_KEY_LOCALE;
exports.i18nConfig = i18nConfig;
exports.locales = locales;
//# sourceMappingURL=index.cjs.map
